import axios from 'axios'
import qs from 'qs'
import Vue from 'vue'
import store from './store'

let client = axios.create({
  baseURL: '/api',
  timeout: 3 * 60 * 1000, //3 min
  headers: {
    'Content-Type': 'application/json',
  },
})

client.interceptors.request.use((config) => {
  let token =
    localStorage.getItem('auth_token_default') ||
    sessionStorage.getItem('auth_token_default')
  if (token) {
    config.headers.common['Authorization'] = `Bearer ${token}`
  }
  config.paramsSerializer = (params) => {
    return qs.stringify(params, {
      arrayFormat: 'brackets',
      encode: false,
    })
  }
  return config
})
client.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response.status === 500) {
      if (err.response.data) {
        Vue.swal({
          type: 'error',
          text: err.response.data.message
            ? err.response.data.message
            : 'Vyskytla sa systémová chyba',
          position: 'top',
          showCloseButton: true,
          timer: 5000,
        })
      }
    } else if (err.response.status === 401 || err.response.status === 440) {
      store.dispatch('user/logout')
      store.dispatch('user/setAuthStatus', {
        code: err.response.status,
        message: err.response.data?.message,
      })
    }
    return Promise.reject(err)
  },
)

export default client
